import axios from 'axios';
import { IInspectionExpense } from './InspectionExpenseModel';

// Base URL ayarı
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

//  BASE URL 
export const INSPECTION_EXPENSE_CREATE_URL = `${API_URL}api/v1/car/definition/inspectionExpense/create`;
export const INSPECTION_EXPENSE_GET_ALL_URL = `${API_URL}api/v1/car/definition/inspectionExpense/all`;
export const INSPECTION_EXPENSE_DELETE_URL = `${API_URL}api/v1/car/definition/inspectionExpense/delete/`;
export const INSPECTION_EXPENSE_UPDATE_URL = `${API_URL}api/v1/car/definition/inspectionExpense/update/`;

// Authorization header helper
const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Create Location (id gönderilmez)
export function createInspectionExpense(InspectionExpenseData: IInspectionExpense) {
    const { id, ...dataWithoutId } = InspectionExpenseData; // id'yi göndermiyoruz
    return axios.post(INSPECTION_EXPENSE_CREATE_URL, dataWithoutId, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });
}

// ✅ Update Location (/update/{id})
export function updateInspectionExpense(InspectionExpenseData: IInspectionExpense) {
    return axios.post(INSPECTION_EXPENSE_UPDATE_URL + InspectionExpenseData.id, InspectionExpenseData, {
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });
}



// ✅ Load all locations (pageable destekli)
export function loadInspectionExpense(page = 0) {
    return axios
        .get(INSPECTION_EXPENSE_GET_ALL_URL, {
            headers: getAuthHeaders(),
            params: { page, size: 20 },
            withCredentials: true,
        })
        .then((res) => ({
            ...res,
            data: res.data.payload?.content || res.data.payload || res.data,
        }));
}

// ✅ Delete Location (/delete/{id})
export function deleteInspectionExpense(InspectionExpenseId: string) {
    return axios.post(INSPECTION_EXPENSE_DELETE_URL + InspectionExpenseId);
}

